import { applyMiddleware, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import errorMiddleware from './middlewares/errorMiddleware'
import { errorActions } from './modules/api/apiUtils'
import reducers from './reducers'

const middlewares = [errorMiddleware(errorActions), thunkMiddleware]

if (process.env.NODE_ENV === 'development') {
    const { logger } = require('redux-logger')
    middlewares.push(logger)
}

const store = createStore(reducers, applyMiddleware(...middlewares))

export default store



// WEBPACK FOOTER //
// ./store.js